export const changeUserStateToAdmin = () => {
    return {
        type : "ADMIN"
    }
}